import { useEffect, useRef, useState } from "react";
import styles from "../../styles/Videos/video.module.css";
import PlayableVideo from "./PlayableVideo";
import { useMediaQuery } from "react-responsive";

const Videos = ({
  videos,
  setVideos,
  setCurrentVideo,
  activeOption,
  setActiveOption,
  handleOptionClick,
  filteredVideos,
  setFilteredVideos,
}) => {
  // const [videos, setVideos] = useState(videosList);
  // const [activeOption, setActiveOption] = useState('All');
  // const [filteredVideos, setFilteredVideos] = useState(videos);
  const isDesktop = useMediaQuery({ minWidth: 786 });
  const [searchValue, setSearchValue] = useState("");
  const recentlyBtn = useRef(null);
  const alphabeticallyBtn = useRef(null);

  useEffect(() => {
    setFilteredVideos(
      videos.filter((video) =>
        video.title.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
  }, [searchValue]);
  const sort = (sortBy) => {
    if (sortBy === "A" && recentlyBtn.current) {
      recentlyBtn.current.classList.remove(`${styles.active}`);
      if (alphabeticallyBtn.current) {
        alphabeticallyBtn.current.classList.add(`${styles.active}`);
      }
    } else if (sortBy === "R" && alphabeticallyBtn.current) {
      alphabeticallyBtn.current.classList.remove(`${styles.active}`);
      if (recentlyBtn.current) {
        recentlyBtn.current.classList.add(`${styles.active}`);
      }
    }
    sortVideos(sortBy);
  };
  const sortVideos = (sortBy) => {
    let sortedVideos = [...videos];
    if (sortBy === "A") {
      sortedVideos.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortBy === "R") {
      sortedVideos.sort(() => Math.random() - 0.5);
    }
    setVideos(sortedVideos);
  };
  return (
    <div style={{ flexGrow: "4", color: "white" }} id="scroll-video-container">
      {!isDesktop && (
        <div style={{ width: "90%", margin: "auto", position: "relative" }}>
          {searchValue === "" && ( // Hide icon when there's input
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "2%",
                transform: "translateY(-50%)",
              }}
            >
              <img src="/search.svg" alt="search-icon" />
            </span>
          )}
          <input
            className={styles.input}
            type="search"
            placeholder="Search course"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      )}

      {/* OPTIONS AND SORT */}
      <div className={styles.optionSortContainer}>
        <div>
          <ul className={styles.optionsContainer}>
            {["All", "Free Trainings", "Featured Trainings"].map((option) => (
              <li
                key={option}
                className={`${styles.option} ${
                  activeOption === option ? styles.optionActive : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.sortBtnContainer}>
          <button
            id="recently-btn"
            ref={recentlyBtn}
            className={`${styles.btn} ${styles.active}`}
            onClick={() => sort("R")}
          >
            Recently
          </button>
          <button
            id="alphabetically-btn"
            ref={alphabeticallyBtn}
            className={`${styles.btn}`}
            onClick={() => sort("A")}
          >
            Alphabetically
          </button>
        </div>
      </div>

      {/* VIDEOS CONTAINER */}
      <div
        id={styles.videosContainer}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          marginLeft: "2rem",
          marginTop: "1.2rem",
        }}
      >
        {filteredVideos.length === 0 && <div>No Records Available</div>}
        {filteredVideos.map((video, index) => (
          <PlayableVideo
            key={index}
            thumbnailUrl={video.thumbnailUrl}
            title={video.title}
            onClick={() => setCurrentVideo(video)}
          />
        ))}
      </div>
    </div>
  );
};

export default Videos;
